module.exports = __webpack_public_path__ + "img/copyright-logo.c592db72.png";